import { TEAM_PERFOMANCE_CARD_TEST_IDS } from '@/constants/data-testids';

import { Skeleton } from '../../atoms/Skeleton/Skeleton';

const TeamPerfomanceCardSkeleton = () => {
  return (
    <div data-testid={TEAM_PERFOMANCE_CARD_TEST_IDS.SKELETON} className="flex flex-col gap-2">
      <div className="flex gap-2 sm:hidden lg:flex">
        <Skeleton className="inline sm:hidden w-3 h-3 rounded-full" />
        <Skeleton className="w-[180px] sm:w-[140px] h-[14px]" />
      </div>
      <div className="flex flex-col lg:hidden">
        <div className="flex items-center gap-2 min-h-[18px]">
          <Skeleton className="w-[60px] h-[14px]" />
          <Skeleton className="w-[30px] h-[14px]" />
        </div>
        <div className="flex items-center gap-2 min-h-[18px]">
          <Skeleton className="w-[30px] h-[14px]" />
          <Skeleton className="w-[200px] h-[14px]" />
        </div>
      </div>
    </div>
  );
};

export default TeamPerfomanceCardSkeleton;
